import { Button } from '@/components/ui/button'

interface TopHeaderProps {
  connected: boolean
  isRunning: boolean
  onOpenWorker: () => void
  onOpenLogs: () => void
  onLogout: () => void
}

const IconWorkers = () => (
  <svg width="13" height="13" viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="1.5">
    <circle cx="7" cy="7" r="2" />
    <path d="M7 1v2M7 11v2M1 7h2M11 7h2M2.93 2.93l1.41 1.41M9.66 9.66l1.41 1.41M2.93 11.07l1.41-1.41M9.66 4.34l1.41-1.41" />
  </svg>
)

const IconLogs = () => (
  <svg width="13" height="13" viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="1.5">
    <rect x="1" y="1" width="12" height="12" rx="1" />
    <line x1="4" y1="5" x2="10" y2="5" />
    <line x1="4" y1="7.5" x2="8" y2="7.5" />
    <line x1="4" y1="10" x2="7" y2="10" />
  </svg>
)

const IconLogout = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="currentColor" strokeWidth="1.5">
    <path d="M7 1H2a1 1 0 00-1 1v8a1 1 0 001 1h5" />
    <path d="M9 4l3 2-3 2" />
    <line x1="12" y1="6" x2="6" y2="6" />
  </svg>
)

export function TopHeader({ connected, isRunning, onOpenWorker, onOpenLogs, onLogout }: TopHeaderProps) {
  return (
    <header className="top-header">
      {/* Brand */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '1px' }}>
        <span
          className="font-mono"
          style={{ fontSize: '13px', fontWeight: 700, color: 'var(--green)', letterSpacing: '0.08em', textTransform: 'uppercase' }}
        >
          FlupArb
        </span>
        <span
          className="font-mono"
          style={{ fontSize: '9px', color: 'var(--text-muted)', letterSpacing: '0.1em', textTransform: 'uppercase' }}
        >
          5-Minute Merge Arbitrage
        </span>
      </div>

      {/* WS / worker status */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginLeft: '20px' }}>
        <span
          className={`live-dot ${connected ? 'animate-pulse-dot' : ''}`}
          style={{ color: connected ? 'var(--green)' : 'var(--text-muted)', fontSize: '8px' }}
        >
          ●
        </span>
        <span
          className="font-mono"
          style={{ fontSize: '9px', letterSpacing: '0.08em', textTransform: 'uppercase', color: connected ? 'var(--green)' : 'var(--text-muted)' }}
        >
          {connected ? 'WS LIVE' : 'WS OFF'}
        </span>

        {isRunning && (
          <>
            <span style={{ color: 'var(--border-strong)', fontSize: '10px', margin: '0 2px' }}>·</span>
            <span
              className="live-dot animate-pulse-dot"
              style={{ color: 'var(--amber)', fontSize: '8px' }}
            >
              ●
            </span>
            <span
              className="font-mono"
              style={{ fontSize: '9px', letterSpacing: '0.08em', textTransform: 'uppercase', color: 'var(--amber)' }}
            >
              RUNNING
            </span>
          </>
        )}
      </div>

      {/* Spacer */}
      <div style={{ flex: 1 }} />

      {/* Action buttons */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <Button
          variant="ghost"
          size="sm"
          onClick={onOpenWorker}
          type="button"
          className="btn btn-ghost btn-sm"
          style={{ fontFamily: 'var(--font-mono)', fontSize: '10px', letterSpacing: '0.06em' }}
        >
          <IconWorkers />
          Controls
        </Button>

        <Button
          variant="ghost"
          size="sm"
          onClick={onOpenLogs}
          type="button"
          className="btn btn-ghost btn-sm"
          style={{ fontFamily: 'var(--font-mono)', fontSize: '10px', letterSpacing: '0.06em' }}
        >
          <IconLogs />
          Logs
        </Button>

        <div style={{ width: '1px', height: '16px', background: 'var(--border-default)', margin: '0 4px' }} />

        <Button
          variant="ghost"
          size="sm"
          onClick={onLogout}
          type="button"
          className="btn btn-ghost btn-sm"
          style={{ fontFamily: 'var(--font-mono)', fontSize: '10px', letterSpacing: '0.06em', color: 'var(--text-muted)' }}
        >
          <IconLogout />
          Logout
        </Button>
      </div>
    </header>
  )
}
